import { useEffect, useState } from "react";
import { getDB } from "./indexedDB";

export function useReferenceOptions() {
  const [referenceOptions, setReferenceOptions] = useState({});

  useEffect(() => {
    async function loadAllDropdowns() {
      const db = await getDB();
      const tx = db.transaction("dropdowns", "readonly");
      const store = tx.objectStore("dropdowns");
      const allEntries = await store.getAll();
      const allKeys = await store.getAllKeys();

      const map = {};

      allKeys.forEach((key, i) => {
        const data = allEntries[i];
        if (data && Array.isArray(data)) {
          map[key] = data.map((opt) => ({
            label: opt.label,
            value: opt.value,
          }));
        }
      });

      setReferenceOptions(map);
    }

    loadAllDropdowns();
  }, []);

  return referenceOptions;
}
